import { inject, Injectable } from '@angular/core';
import { PermissionService } from '@tiltgroup/web-components';
import {
  QueryPermissionKey,
  queryPermissionMap,
  queryPermissions,
} from '@shared/interfaces/permission';
import { Sort } from '@angular/material/sort';

@Injectable({
  providedIn: 'root',
})
export class QueriesBaseService {
  private _permissionService = inject(PermissionService);

  getQueryPermissions(data: QueryPermissionKey[]): queryPermissions {
    const permissions = {};
    data.forEach(
      (permission) =>
        (permissions[permission] = this._permissionService.checkPermission(
          queryPermissionMap[permission]
        ))
    );

    return permissions as queryPermissions;
  }

  orderBy(sort: Sort) {
    return [
      {
        column: sort?.active.toUpperCase(),
        order: sort?.direction.toUpperCase(),
      },
    ];
  }
}
